import * as React from "react";
import {BaseComponent} from "../BaseComponent/BaseComponent";
import DeleteDialog from "components/Dialog/DeleteDialog";

interface OpenDeleteDialogMenuItemProps {
    dialogTitle: string;
    label?: string;
    disabled: boolean;
    deleteButtonLabel?: string;
    deleteButtonBusyLabel?: string;
    onDeleteClick(): Promise<boolean>;
}

interface OpenDeleteDialogMenuItemState {
    open: boolean;
}

export default class OpenDeleteDialogMenuItem extends BaseComponent <OpenDeleteDialogMenuItemProps, OpenDeleteDialogMenuItemState> {
    constructor(props: OpenDeleteDialogMenuItemProps) {
        super(props);
        this.state = {open: false};
    }

    onClick = () => {
        this.setState({open: true});
    }

    render() {
        return <DeleteDialog
            title={this.props.dialogTitle}
            open={this.state.open}
            deleteButtonLabel={this.props.deleteButtonLabel}
            deleteButtonBusyLabel={this.props.deleteButtonBusyLabel}
            onClose={() => this.setState({open: false})}
            onDeleteClick={() => this.props.onDeleteClick()}>
            {this.props.children}
        </DeleteDialog>;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Menu/OpenDeleteDialogMenuItem.tsx